module.exports = __webpack_public_path__ + "static/img/nav14.7ba0c4b6.svg";